import React, { PureComponent } from 'react';
import styles from './style.module.scss';

export default class TopPostCard extends PureComponent {
  render() {
    const { topPost } = this.props;

    return (
      <article
        className={`${styles.topPostContainer} ${this.props.className || ''}`}
      >
        <img
          alt=""
          loading="lazy"
          src={topPost.image}
          className={styles.topPostCardImage}
        />
        <h3>{topPost.title}</h3>
        <a href={topPost.link}>Read More</a>
      </article>
    );
  }
}
